import React from 'react';
import { Typography, Grid, Divider } from '@mui/material';

const ProductFullDetails = ({ selectedProduct }) => {
  console.log(selectedProduct);
  return (
    <div>
      {selectedProduct && (
        <div style={{ marginTop: "2rem" }}>
          <Grid
            container
            sx={{ width: "100%" }}
            columnSpacing={{ xs: 1, sm: 2, md: 4 }}
          >
            <Grid item size={{ xs: 12, sm: 12, md: 4 }} sx={{
              borderRight: "1px solid #ddd"
            }}>
              <Typography variant="h6" className="titleSec" gutterBottom>
                Product Details:
              </Typography>

              {selectedProduct.sku_id && (
                <Typography>
                  <strong>SKU ID:</strong> {selectedProduct.sku_id}
                </Typography>
              )}

              {selectedProduct?.fda && (
                <Typography>
                  <strong>FDA:</strong> {selectedProduct?.fda}
                </Typography>
              )}
              {selectedProduct.manufacturer && (
                <Typography>
                  <strong>Manufacturer:</strong>{" "}
                  {selectedProduct.manufacturer}
                </Typography>
              )}

              {selectedProduct.distributor && (
                <Typography>
                  <strong>Distributor:</strong> {selectedProduct.distributor}
                </Typography>
              )}

              {selectedProduct.warranty && (
                <Typography>
                  <strong>Warranty:</strong> {selectedProduct.warranty}
                </Typography>
              )}

              {selectedProduct.sterility !== undefined && (
                <Typography>
                  <strong>Sterility:</strong>{" "}
                  {selectedProduct.sterility ? "Yes" : "No"}
                </Typography>
              )}

              {selectedProduct.disposable !== undefined && (
                <Typography>
                  <strong>Disposable:</strong>{" "}
                  {selectedProduct.disposable ? "Yes" : "No"}
                </Typography>
              )}

              {selectedProduct.usage && (
                <Typography>
                  <strong>Usage:</strong> {selectedProduct.usage}
                </Typography>
              )}

              {selectedProduct?.material && (
                <Typography>
                  <strong>Material:</strong>
                  {selectedProduct?.material=='latex'?" Latex":" Latex Free"}
                </Typography>
              )}

              {selectedProduct.replacementPolicy && (
                <Typography>
                  <strong>Replacement Policy:</strong>{" "}
                  {selectedProduct.replacementPolicy}
                </Typography>
              )}

              {/* {selectedProduct.highlights?.length > 0 && (
                        <div>
                            <Typography><strong>Highlights:</strong></Typography>
                            <ul>
                                {selectedProduct.highlights.map((highlight, index) => (
                                    <li key={index}>
                                        <Typography>{highlight}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )} */}
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 4 }} sx={{
              borderRight: "1px solid #ddd"
            }}>
              {selectedProduct.specification?.length > 0 && (
                <div>
                  <Typography>
                    <strong>Specification:</strong>
                  </Typography>
                  <ul>
                    {selectedProduct.specification.map((highlight, index) => (
                      <li key={index}>
                        <Typography>{highlight}</Typography>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedProduct.ingredients?.length > 0 && (
                <div>
                  <Typography>
                    <strong>Ingredients:</strong>
                  </Typography>
                  <ul>
                    {selectedProduct.ingredients.map((highlight, index) => (
                      <li key={index}>
                        <Typography>{highlight}</Typography>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
              {selectedProduct.description && (
                <Typography>
                  <strong>Description:</strong> {selectedProduct.description}
                </Typography>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default ProductFullDetails;
